import { IProductCarousel } from '../../types/IProductCarousel';
import ipenSesh01 from '../assets/product-screens/ipensesh-01.jpg';
import ipenSesh02 from '../assets/product-screens/ipensesh-02.jpg';
import ipenSesh03 from '../assets/product-screens/ipensesh-03.jpg';
import ipenSesh04 from '../assets/product-screens/ipensesh-04.jpg';
import ipenSesh05 from '../assets/product-screens/ipensesh-05.jpg';

export const ipenSessionWalkThru: IProductCarousel = {
  steps: [
    {
      title: 'Verify Your Information',
      imageUrl: ipenSesh01,
      points: [
        {
          title: '',
          description:
            'A verification screen will appear to take you to the IPEN session. Please verify your information and click CONFIRM & LAUNCH SESSION to continue. You can click EDIT PROFILE on the verification screen if you believe your information is incorrect.',
        },
      ],
    },
    {
      title: 'Activate Signer Session',
      imageUrl: ipenSesh02,
      points: [
        {
          title: '',
          description:
            'Activate one signer at a time so each signer can complete their signing session.',
        },
      ],
    },
    {
      title:
        'Choose how signers would like to sign their documents: will they use a personal device, or will they share your device?',
      imageUrl: ipenSesh03,
      points: [
        {
          title: 'Using a Personal Devices',
          description:
            'If the signer chooses to use their device, click and show the QR code.',
        },
        {
          title: 'Sharing Device',
          description:
            "If the signer chooses to share your device, click REVIEW & SIGN to open the signer's session in a new tab, then pass your device to the signer.",
        },
      ],
    },
    {
      title: 'Notary Seal & Sign',
      imageUrl: ipenSesh04,
      points: [
        {
          title: '',
          description:
            'Once all the signers have reviewed and signed their documents, click REVIEW & SIGN next to your name to complete notarizing them.',
        },
      ],
    },
    {
      title: 'Session Complete',
      imageUrl: ipenSesh05,
      points: [
        {
          title: '',
          description:
            'Once all parties have signed, the IPEN session window will automatically close.',
        },
      ],
    },
  ],
};
